import { render, staticRenderFns } from "./cv-tile.vue?vue&type=template&id=3608129f&"
import script from "./cv-tile.vue?vue&type=script&lang=js&"
export * from "./cv-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports